export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const TOGGEL = "TOGGEL";
export const CLEAR_CART = "CLEAR_CART";
export const SET_ITEMS = "SET_ITEMS";
export const FETCHED_ITEMS_FAILS = "FETCHED_ITEMS_FAILS";
export const RESET = "RESET";
export const SET_OUTLETS = "SET_OUTLETS";
export const FETCHED_OUTLETS_FAILS = "FETCHED_OUTLETS_FAILS";
export const IS_LOADING_OUTLETS = "IS_LOADING_OUTLETS";
export const STATUS_CHANGE = "STATUS_CHANGE";
export const NOT_LOADING = "NOT_LOADING";
export const IS_LOADING_RECORDS = "IS_LOADING_RECORDS";
export const SET_RECORDS = "SET_RECORDS";
export const TOGGEL_LOADING = "TOGGEL_LOADING";
export const FETCHED_RECORDS_FAILS = "FETCHED_RECORDS_FAILS";
export const RESETOUTLETS = "RESETOUTLETS";
export const RESET_RECORDS="RESET_RECORDS";